import { render, staticRenderFns } from "./LaboralReferences.vue?vue&type=template&id=158f7f43&"
import script from "./LaboralReferences.vue?vue&type=script&lang=js&"
export * from "./LaboralReferences.vue?vue&type=script&lang=js&"
import style0 from "./LaboralReferences.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('158f7f43')) {
      api.createRecord('158f7f43', component.options)
    } else {
      api.reload('158f7f43', component.options)
    }
    module.hot.accept("./LaboralReferences.vue?vue&type=template&id=158f7f43&", function () {
      api.rerender('158f7f43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/candidates/laboral-references/LaboralReferences.vue"
export default component.exports